module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('z-basePage', {
    attrs: {
      "title": '岗位设置'
    }
  }, [_c('div', {
    staticClass: "btns-top bottom"
  }, [_c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.addItem
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn blue",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('z-scrollDiv', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-post'),
      expression: "'back-post'"
    }],
    staticClass: "post-main"
  }, [_vm._l((_vm.allPost), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "post-item"
    }, [_c('div', {
      staticClass: "back-item"
    }, [_c('div', {
      staticClass: "back-title"
    }, [_vm._v("岗位名称")]), _vm._v(" "), _c('div', {
      staticClass: "back-wrap"
    }, [_c('el-input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (item.positionName),
        expression: "item.positionName"
      }],
      staticClass: "top-choose",
      attrs: {
        "rule": "noVal"
      },
      model: {
        value: (item.positionName),
        callback: function($$v) {
          _vm.$set(item, "positionName", $$v)
        },
        expression: "item.positionName"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "back-item"
    }, [_c('div', {
      staticClass: "back-title"
    }, [_vm._v("每级工资")]), _vm._v(" "), _c('div', {
      staticClass: "back-wrap"
    }, [_c('el-input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (item.gradeSalary),
        expression: "item.gradeSalary"
      }],
      staticClass: "top-choose",
      attrs: {
        "rule": "noVal number positive"
      },
      model: {
        value: (item.gradeSalary),
        callback: function($$v) {
          _vm.$set(item, "gradeSalary", $$v)
        },
        expression: "item.gradeSalary"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("元")])], 2)], 1)])])
  }), _vm._v(" "), _vm._l((_vm.add_list), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "post-item"
    }, [_c('div', {
      staticClass: "back-item"
    }, [_c('div', {
      staticClass: "back-title"
    }, [_vm._v("岗位名称")]), _vm._v(" "), _c('div', {
      staticClass: "back-wrap"
    }, [_c('el-input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (item.positionName),
        expression: "item.positionName"
      }, {
        name: "arg",
        rawName: "v-arg",
        value: ('岗位名称'),
        expression: "'岗位名称'"
      }],
      staticClass: "top-choose",
      attrs: {
        "rule": "noVal"
      },
      model: {
        value: (item.positionName),
        callback: function($$v) {
          _vm.$set(item, "positionName", $$v)
        },
        expression: "item.positionName"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "back-item"
    }, [_c('div', {
      staticClass: "back-title"
    }, [_vm._v("每级工资")]), _vm._v(" "), _c('div', {
      staticClass: "back-wrap"
    }, [_c('el-input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (item.gradeSalary),
        expression: "item.gradeSalary"
      }, {
        name: "arg",
        rawName: "v-arg",
        value: ('每级工资'),
        expression: "'每级工资'"
      }],
      staticClass: "top-choose",
      attrs: {
        "rule": "noVal number positive"
      },
      model: {
        value: (item.gradeSalary),
        callback: function($$v) {
          _vm.$set(item, "gradeSalary", $$v)
        },
        expression: "item.gradeSalary"
      }
    }, [_c('template', {
      slot: "append"
    }, [_vm._v("元")])], 2)], 1)]), _vm._v(" "), _c('div', {
      staticClass: "back-btn red",
      on: {
        "click": function($event) {
          _vm.clearItem(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.allPost.concat( _vm.add_list)
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-400b55bf!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/setting/page-post.vue
// module id = 730
// module chunks = 1